import {AutoScrollService} from "@numizmat/services/common";
import {AfterViewInit, Directive, inject} from '@angular/core';

@Directive({
  selector: '[nzRestoreScrollPosition]',
  standalone: true
})
export class RestoreScrollPositionDirective implements AfterViewInit {
  autoScrollService = inject(AutoScrollService);

  ngAfterViewInit(): void {
    this.autoScrollService.shouldScroll.next(true);
  }
}
